import { Directive, Input, inject } from '@angular/core';
import { AbstractBasketComponent } from '@df/basket/abstract-basket.component';
import { NgInject } from '@df/ng/ng-inject';
import { PriceService } from '@df/ui/price/price.service';
import keys from 'lodash-es/keys';
import pick from 'lodash-es/pick';
import values from 'lodash-es/values';

export namespace NBasketFreeShipping {
    export interface IFreeshipping {
        [method: string]: boolean;
    }

    export interface IFreeshippingminamount {
        name: string;
        value: number;
    }

    export interface IFreeshippingminamountExt extends IFreeshippingminamount {
        isFullfilled: boolean;
        neededValue: number;
    }
}

declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.Basket {
        interface BasketData {
            freeshippingminamounts?: NBasketFreeShipping.IFreeshippingminamount[];
            freeshipping?: NBasketFreeShipping.IFreeshipping;
        }
    }
}

@Directive()
export class BasketFreeDeliveryNoticeComponentDef extends AbstractBasketComponent {
    /**
     * Synced rules prepared in every change detection
     */
    rules: NBasketFreeShipping.IFreeshippingminamountExt[] | undefined;

    /**
     * Price service
     */
    private priceService = inject(PriceService);

    @Input()
    subtotalWithDiscount = false;

    /**
     * Retrieves list of free shiepping rules applicable for the basket
     */
    private getRules(): NBasketFreeShipping.IFreeshippingminamountExt[] | undefined {
        if (!this.basket.qty) {
            return;
        }
        const basketData = this.basket.data;
        return (
            basketData.freeshippingminamounts &&
            basketData.freeshipping &&
            values(pick(basketData.freeshippingminamounts, keys(basketData.freeshipping)))
                .filter(rule => !!rule)
                .map(rule => {
                    const isFullfilled = this.isFullfilled(rule!);
                    return {
                        ...rule!,
                        isFullfilled,
                        neededValue: isFullfilled ? 0 : rule!.value - this.subtotalValue
                    };
                })
        );
    }

    /**
     * If rule is fullfilled test
     */
    isFullfilled(rule: NBasketFreeShipping.IFreeshippingminamount): boolean {
        return this.basket.data.totals ? rule.value <= this.subtotalValue : false;
    }

    /**
     * Prepares prices string
     */
    toPriceString(value: number): string | undefined {
        return this.priceService.toPlainString(value);
    }

    override detectChanges(): void {
        this.rules = this.getRules();
        super.detectChanges();
    }

    get subtotalValue() {
        return this.subtotalWithDiscount ? this.basket.subtotalWithDiscount : this.basket.subtotal;
    }
}
